/** parseActionFilters produce a filter object (see example) populated
 * from the given URLSearchParams object. */
export const parseActionFilters = (params /* URLSearchParams */) => ({
  // Filters
  at: params.get("at"),
  by_id: params.get("by_id"), // id matches exactly
  by_ctns: params.get("by_ctns"), // id matches exactly
  sort_order: params.get("sort_order") || "DESC", // The sort order
  sort_by: params.get("sort_by") || "at", // The column to sort by
})
